import React from 'react';
import SingleTabGroup from './SingleTabGroup';
import MoreButton from '../Custom/PopOver/MoreButton';
import PopOver from '../Custom/PopOver/PopOver';
import styles from '../../Template/SingleApplicantTemplate/SingleApplicantPage.module.css';
import moreicon from '../../../assets/Imagess/moreicon.svg';
import exportICon from '../../../assets/Imagess/exportIcon.svg';
import printicon from '../../../assets/Imagess/printIcon.svg';
import {
  useFetchGenerateInterestedPdf,
  useFetchGeneratePdf,
} from '../../../Hooks/SingleApplicant';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
const SingleApplicantNav = ({
  applicant,
  tabContainer,
  selected,
  setSelected,
  handlePrint,
}) => {
  const { id } = useParams();
  const generatePdf = useFetchGenerateInterestedPdf();

  const handleGeneratePdf = async () => {
    try {
      const response = await generatePdf.mutateAsync(id);
      const fileURL = response?.data?.fileURL;

      if (!fileURL) {
        toast.error('PDF URL not found');
        return;
      }

      // Force open in new tab
      const newWindow = window.open('', '_blank');
      if (!newWindow) {
        toast.error('Popup blocked! Please allow popups.');
        return;
      }

      // then set the URL
      newWindow.location.href = fileURL;

      toast.success('PDF Generated Successfully');
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Failed to generate PDF');
    }
  };

  return (
    <div className={styles['tab-singleapp-container']}>
      <SingleTabGroup
        tabContainer={tabContainer}
        selected={selected}
        setSelected={setSelected}
      />

      <MoreButton icon={moreicon} toolTipText='More'>
        <PopOver
          stop
          info={[
            {
              title: 'Export',
              icon: exportICon,
              handleFunction: handleGeneratePdf,
            },
            {
              title: 'Print',
              icon: printicon,
              handleFunction: handlePrint,
            },
          ]}
        />
      </MoreButton>
    </div>
  );
};

export default SingleApplicantNav;
